export function rxsecret () {
  const result = []
  result.web_port = 4444
  result.base_api = 'http://13.213.42.49:4443'
  result.theme = 'default'
  return result
}
